import React,{useState, useEffect} from 'react'
import AdminMenu from './../../components/Layout/AdminMenu.js';
import Layout from './../../components/Layout/Layout.js';
import axios from 'axios';
import toast from 'react-hot-toast';
import { Link } from 'react-router-dom';
import "../../styles/AdminStyles.css";

const Products = () => {
    const [products,setProducts] = useState([]);

    const getAllProducts = async () => {
        try {
            const {data} = await axios.get('/api/v1/products/get-product');
            setProducts(data.products);
        } catch (error) {
            console.log(error);
            toast.error('حدث خطأ ما');
        }
    };

    useEffect(() => {
        getAllProducts();
    }, []);

  return (
    <Layout title={'جميع المنتجات - النخبة ستور'}>
      <div className='container-fluid admin-layout'>
        <div className='row'>
          <div className='col-md-3'>
            <AdminMenu />
          </div>
          <div className='col-md-9'>
            <div className="admin-page-header">
              <h1>قائمة المنتجات</h1>
              <p>عرض وإدارة جميع المنتجات ({products?.length || 0} منتج)</p>
              <div className="admin-page-header-line"></div>
            </div>

            {products?.length > 0 ? (
              <div className='admin-products-grid'>
                {products?.map((p, index) => (
                  <Link key={p._id} to={`/dashboard/admin/products/${p.slug}`} className='admin-product-card' style={{animationDelay: `${index * 0.06}s`}}>
                    <div className="card-img-wrapper">
                      <img src={`/api/v1/products/product-photo/${p._id}`} alt={p.name} loading="lazy" />
                    </div>
                    <div className="card-body">
                      <h5 className="card-title">{p.name}</h5>
                      <p className="card-text">{p.description.substring(0, 60)}...</p>
                    </div>
                  </Link>
                ))}
              </div>
            ) : (
              <div className="empty-state" style={{marginTop: '40px'}}>
                <div className="empty-state-icon">📦</div>
                <h4>لا توجد منتجات</h4>
                <p>ابدأ بإنشاء منتجات جديدة من قائمة الإدارة</p>
              </div>
            )}
          </div>
        </div>
      </div>
    </Layout>
  );
};

export default Products;
